import { AxiosError } from 'axios';
import { StatusCodes } from 'http-status-codes';
import { getApiErrorStatusCode } from 'logic/axios/axios-api-error';

export const isNotActivatedPhoneError = (error: AxiosError) =>
  getApiErrorStatusCode(error) === StatusCodes.FORBIDDEN &&
  error.response?.data.error === 'NOT_ACTIVATED_PHONE_NUMBER';
